const TOKEN_KEY = 'h5_requirement_token'
const PASSWORD_RESET_TOKEN_KEY = 'h5_password_reset_token'

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  window.localStorage.removeItem(TOKEN_KEY)
}

export function getPasswordResetToken() {
  return window.sessionStorage.getItem(PASSWORD_RESET_TOKEN_KEY) || ''
}

export function setPasswordResetToken(token) {
  window.sessionStorage.setItem(PASSWORD_RESET_TOKEN_KEY, token)
}

export function removePasswordResetToken() {
  window.sessionStorage.removeItem(PASSWORD_RESET_TOKEN_KEY)
}
